<template>
  <defs>
    <linearGradient x1="50%" y1="100%" x2="50%" y2="0%" :id="generatedId">
      <stop stop-color="#C514B4" offset="0%"/>
      <stop stop-color="#F05027" offset="100%"/>
    </linearGradient>
  </defs>
  <g :stroke="`url(#${generatedId})`" fill="none" fill-rule="evenodd">
    <path stroke-linecap="square" d="M22.5 3.5v19M22.5 22.5h-19"/>
    <path d="M22.5 22.5.5.5"/>
  </g>
</template>

<script>
import { generate5DigitId } from '@/utils/id';

export default {
  name: 'IconArrowRightBottomGradient',
  data() {
    return {
      generatedId: `arrow-right-gradient-${generate5DigitId()}`,
    };
  },
};
</script>
